import { render } from "./contact.vue?vue&type=template&id=3118afa1&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=3118afa1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3118afa1"

export default script